import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import StyleVariables from "../../../assets/styles/Variable.module.scss";
import {
  DateBuddhistEra as DateBuddhistEraUtil,
  DateTimeBuddhistEra as DateTimeBuddhistEraUtil,
} from "../../../utils/DateFormat";
import dayjs from "dayjs";
import { NumericFormat } from "react-number-format";
import { RefInvoice as RefInvoiceConstant } from "../../../constants/Gold";
import {
  RenewBillTypeKey as RenewBillTypeKeyDepositConstant,
  RenewBillTypes as RenewBillTypesDepositConstant,
} from "../../../constants/Deposit";
import { Return as ReturnModel } from "../../../models/Return";
import SouvenirsBill from "../Souvenirs";

type Props = {
  depositReturn: ReturnModel | null;
};

const ReturnCancel = observer((props: Props) => {
  const nameRenewBillDeposit = () => {
    return (
      RenewBillTypesDepositConstant.find(
        (item) => item.value === props.depositReturn?.type
      )?.label || ""
    );
  };

  return (
    <Box color={StyleVariables["color-text"]}>
      {/* Heading */}
      <Box borderBottom={`1px dashed ${StyleVariables["color-border"]}`}>
        {/* Branch Name && Ref Invoice Number */}
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          gap={1}
          marginBottom={1}
        >
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.depositReturn?.deposit?.branchName}
          </Typography>
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.depositReturn?.refInvoiceNo
              ? `${props.depositReturn?.refInvoiceNo}`
              : "X-XXXXXXXX-XXXX"}
          </Typography>
        </Box>
        {/* /.Branch Name && Ref Invoice Number */}

        {/* Employee Name && Returned Date */}
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          gap={1}
          marginBottom={2}
        >
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.depositReturn?.cancelByUserFirstName}{" "}
            {props.depositReturn?.cancelByUserLastName &&
              props.depositReturn?.cancelByUserLastName[0]}
            .
          </Typography>
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.depositReturn?.returnedAt
              ? DateTimeBuddhistEraUtil(props.depositReturn?.returnedAt)
              : `${DateBuddhistEraUtil(dayjs())} --:--`}
          </Typography>
        </Box>
        {/* /.Employee Name && Returned Date */}
      </Box>
      {/* /.Heading */}

      {/* Return Price */}
      <Box marginY={2}>
        <Grid container spacing={2} alignItems={"center"}>
          <Grid item xs={8}>
            <Typography variant="subtitle2" fontWeight={"regular"}>
              คืนบิลหมายเลข
              <br />
              {props.depositReturn?.deposit?.refInvoiceNo?.replace(
                `${RefInvoiceConstant.deposit}-`,
                ""
              )}
            </Typography>
            <Typography variant="caption" fontWeight={"regular"} marginTop={1}>
              {"("}
              <NumericFormat
                value={props.depositReturn?.deposit?.depositPrice}
                displayType="text"
                thousandSeparator
              />{" "}
              +{" "}
              <NumericFormat
                value={
                  (props.depositReturn?.interest || 0) +
                  (props.depositReturn?.chargeCard || 0)
                }
                displayType="text"
                thousandSeparator
              />{" "}
              ={" "}
              <NumericFormat
                value={
                  props.depositReturn?.type ===
                  RenewBillTypeKeyDepositConstant.return
                    ? props.depositReturn?.netPay
                    : (props.depositReturn?.deposit?.depositPrice || 0) +
                      (props.depositReturn?.interest || 0) +
                      (props.depositReturn?.chargeCard || 0)
                }
                displayType="text"
                thousandSeparator
              />
              {")"}
            </Typography>
          </Grid>
          <Grid item xs={4} textAlign={"right"}>
            <Typography variant="subtitle2" fontWeight={"regular"}>
              <NumericFormat
                value={
                  props.depositReturn?.type ===
                  RenewBillTypeKeyDepositConstant.return
                    ? props.depositReturn?.netPay
                    : (props.depositReturn?.deposit?.depositPrice || 0) +
                      (props.depositReturn?.interest || 0) +
                      (props.depositReturn?.chargeCard || 0)
                }
                displayType="text"
                thousandSeparator
              />
            </Typography>
          </Grid>
        </Grid>
      </Box>
      {/* /.Return Price */}

      {/* Renew Bill Type */}
      {props.depositReturn?.type !== RenewBillTypeKeyDepositConstant.return ? (
        <Box marginTop={3} marginBottom={2} textAlign={"center"}>
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.depositReturn?.type !==
            RenewBillTypeKeyDepositConstant.purchase
              ? `ยกเลิกไปต่อบิลใหม่ ${props.depositReturn?.refInvoiceNoNext?.replace(
                  `${RefInvoiceConstant.deposit}-`,
                  ""
                )} (${nameRenewBillDeposit()})`
              : "ยกเลิก (ตัดขาย)"}
          </Typography>
        </Box>
      ) : null}
      {/* /.Renew Bill Type */}

      <SouvenirsBill
        souvenirs={props.depositReturn?.souvenirs}
        showBorderTop={true}
        showBorderBottom={false}
      />

      <Typography
        variant="subtitle2"
        fontWeight={"regular"}
        marginTop={2}
        paddingBottom={2}
        textAlign={"center"}
        whiteSpace={"break-spaces"}
        borderBottom={`1px dashed ${StyleVariables["color-border"]}`}
      >
        {"ยกเลิก  ยกเลิก  ยกเลิก  ยกเลิก  ยกเลิก"}
      </Typography>
      <Typography variant="subtitle2" fontWeight={"regular"} marginTop={2}>
        เหตุผล:{" "}
        {`${props.depositReturn?.cancelReason?.reason} ${
          props.depositReturn?.cancelMisc || ""
        }`}
      </Typography>
    </Box>
  );
});

export default ReturnCancel;
